import { useEffect, useState } from "react";
import { fetchProducts, fetchPrices, fetchTemplates } from "@/lib/api";

let cache = null;

export const useCatalog = () => {
  const [data, setData] = useState(cache);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    if (cache) return;
    let alive = true;
    Promise.all([fetchProducts(), fetchPrices(), fetchTemplates()])
      .then(([products, prices, templates]) => {
        cache = { products, prices, templates };
        if (alive) {
          setData(cache);
          setLoading(false);
        }
      })
      .catch(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, []);

  const priceOf = (productCode, quantity) =>
    data?.prices.find((p) => p.product_code === productCode && p.quantity === quantity)?.price ?? 0;

  const productOf = (code) => data?.products.find((p) => p.code === code) || null;
  const templateOf = (id) => data?.templates.find((t) => t.template_id === id) || null;

  return {
    loading,
    products: data?.products || [],
    prices: data?.prices || [],
    templates: data?.templates || [],
    priceOf,
    productOf,
    templateOf,
  };
};
